import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { UserIcon } from '../../../../images/icons/WrapSvg';

class FilterMenu extends React.Component {
    handleClick = (option) => (event) => {
        this.props.handleClose(option);
    };

    render() {
        const { intl, anchorEl, active } = this.props;
        return (
            <Menu
                id="recipe-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClick(undefined)}
                className="z_index_dialog_over_dialog"
            >
                <MenuItem className={'bg_ice_blue'} onClick={this.handleClick('employees')}>
                    <ListItemIcon className={'icon c_bluish'}>
                        <UserIcon />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'barlow_semibold_label c_bluish' }}
                        inset
                        primary={intl.formatMessage({
                            id: active ? 'popup_active_users' : 'popup_all_users',
                        })}
                    />
                </MenuItem>
            </Menu>
        );
    }
}

FilterMenu.propTypes = {
    intl: intlShape.isRequired,
};

FilterMenu = injectIntl(FilterMenu);

export default FilterMenu;



// WEBPACK FOOTER //
// ./src/components/complex/manage/customers/FilterMenu.js